import React from 'react';
import { ReferenceField, TextField } from 'react-admin';
import { CopyField } from './CopyField';

function TransactionReferenceField(props) {
  return (
    <ReferenceField reference="transactions" {...props}>
      #
      <CopyField source="id" label="ID" />
    </ReferenceField>
  );
}
TransactionReferenceField.defaultProps = {
  label: 'Transaction',
  source: 'transactionId',
};

export default TransactionReferenceField;
